module.exports = {
      id: "women-home-usage",
      viewBox: "0 0 64.575 75.722",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#women-home",
      toString: function () {
        return this.url;
      }
    }